// extracted by mini-css-extract-plugin
export default {"order":"productList_order__66NW6","type-order":"productList_type-order__OLDJG","products":"productList_products__2XXTg"};